import { render, staticRenderFns } from "./box1.vue?vue&type=template&id=171c349c&scoped=true&"
import script from "./box1.vue?vue&type=script&lang=js&"
export * from "./box1.vue?vue&type=script&lang=js&"
import style0 from "./box1.vue?vue&type=style&index=0&id=171c349c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171c349c",
  null
  
)

export default component.exports